export default __webpack_public_path__ + "static/media/refresh.42f1da95.svg";